import React from "react";
import { DeleteLayerConainer } from "../styled/dashboard";

const DeleteLayer = ({ openModal, deleteSelectedNotis, closeModal, deleteAllNotis }) => {
  return (
    <DeleteLayerConainer>
      <button
        onClick={() =>
          openModal({
            isOpen: true,
            type: "confirmation",
            title: `알림 삭제`,
            message: ["선택된 알림을 삭제하시겠습니까?"],
            handleConfirm: () => deleteSelectedNotis(),
            handleCancel: () => closeModal(),
          })
        }>
        선택 알림 삭제
      </button>
      <button
        onClick={() =>
          openModal({
            isOpen: true,
            type: "confirmation",
            title: `알림 삭제`,
            message: ["모든 알림을 삭제하시겠습니까?"],
            handleConfirm: () => deleteAllNotis(),
            handleCancel: () => closeModal(),
          })
        }>
        전체 알림 삭제
      </button>
    </DeleteLayerConainer>
  );
};

export default DeleteLayer;
